// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"1c7f3959","172":"30e2ff4c","372":"87aaec6f","442":"cb2cca3b","487":"d6df2676","788":"3ff4f5d7"}[chunkId] + ".chunk.js";
};